import { Step } from "../../../../types/Step";
import { View } from "../../../../types/Views";
import IUserEvent from "../../Types/IUserEvent";
import StepArrivalUserEvent from "../../Types/StepArrivalUserEvent";
import ViewArrivalUserEvent from "../../Types/ViewArrivalUserEvent";

const StepOrViewArrivedEventFactory = (eventData: string): IUserEvent<Step | View> => {
  try {
    return new StepArrivalUserEvent(eventData);
  } catch {
    return new ViewArrivalUserEvent(eventData);
  }
};

export default StepOrViewArrivedEventFactory;
